import { legacyHttpClient } from "@services/http/legacyHttpClient";

export interface EventPaymentDiscount {
  paymentMethodCode: string;
  percentage: number;
}

/**
 * Fetch active payment discounts for an event.
 * GET /rest/api/web/events/{eventId}/payment-discounts
 *
 * Informational/UI only — never blocks checkout. Returns an empty
 * array on any network/API error so callers can render without discounts.
 */
export async function getEventPaymentDiscounts(
  eventId: number | string,
): Promise<EventPaymentDiscount[]> {
  try {
    return await legacyHttpClient.get<EventPaymentDiscount[]>(
      `/api/web/events/${eventId}/payment-discounts`,
    );
  } catch {
    return [];
  }
}
